<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <span style="font-weight: 700" class="text-uppercase">WKZ-Trendblog</span>
      <div style="float:right">
        <span class="dot-red"
              v-if="!channels[index].foreign_id || (channels[index].publish_later && !publishLaterIsPast(channels[index].publish_at))"
              content="Wird in der App nicht angezeigt" v-tippy></span>
        <span class="dot-green" content="Wird in der App angezeigt" v-else v-tippy></span>
      </div>
    </div>
    <div class="panel-body" v-if="record.client_has_app">
      <div>
        <label for="name_internal" class="control-label">Interner Name</label>
        <input name="name_internal"
               type="text"
               id="name_internal"
               class="form-control"
               v-model="channels[index].name_internal">
      </div>
      <div style="padding-bottom: 40px;">
        <label for="">Kategorie</label>
        <Select2 v-model="channels[index].category_id" :options="Categories"/>
      </div>
      <vue-toastr ref="toast"></vue-toastr>
      <div style="padding-bottom: 40px;">
        <label for="">Slidervorschaubild</label>
        <a class="fa fa-question-circle" v-tippy
           content="Wir empfehlen eine Bildgröße von 1080 × 1350 Pixeln im Format 4:5. Alternativ können auch proportional größere Abmessungen verwendet werden."></a>
        <content-preview :index="index" :scale-height="1350" :scale-width="1080"
                         :content-prop="{url: channels[index].preview_image_url, type: 'preview'}"
                         @update:channels="channelsUpdated"></content-preview>
      </div>
      <label for="">Beitragsbild</label>
      <a class="fa fa-question-circle" v-tippy
         content="Wir empfehlen eine Bildgröße von 1080 × 1350 Pixeln im Format 4:5. Alternativ können auch proportional größere Abmessungen verwendet werden. Die maximale Dateigröße bei Videos beträgt 10MB"></a>
      <content-preview :index="index" :scale-height="1350" :scale-width="1080"
                       :content-prop="{url: channels[index].content_url, type: 'content'}"
                       @update:channels="channelsUpdated"></content-preview>
      <br>
      <div :class="['ckeditor-wrapper', {'ckeditor-error': submitAttempted && !channels[index].news_content}]">
        <label style="margin-bottom: 10px">Content</label>
        <a class="fa fa-question-circle" v-tippy
           content="Hier können alle Infos zum Beitrag stehen. Außerdem können Links eingefügt werden."></a>
        <VueEditor ref="editor" v-model="channels[index].news_content" :editor-toolbar="toolbar"></VueEditor>
      </div>
      <br>
      <div>
        <div v-for="(additionalContent,contentIndex) in channels[index].additional_content">
          <magazine-additional-content :channel="channels[index]" :index="contentIndex"
                                       :additional-content="additionalContent" :editor-config="editorConfig"
                                       :news-hub="channels[index].dbRecord"></magazine-additional-content>
        </div>
        <div class="btn btn-success col-md-12" @click="addAdditionalContent">
          <a class="fa fa-plus text-white"></a>&nbsp;Beitrag erweitern
        </div>
        <br>
        <br>
        <div class="form-group">
          <input type="checkbox" :id="`has_expiration_date${channels[index].id}`"
                 v-model="channels[index].has_expiration_date">
          <label :for="`has_expiration_date${channels[index].id}`">Ablaufdatum aktivieren</label>
        </div>
        <div class="form-group" v-if="channels[index].has_expiration_date">
          <label for="expiry_date">Ablaufdatum</label>
          <input type="datetime-local" v-model="channels[index].expiry_date" class="form-control">
        </div>
        <div class="form-group">
          <input type="checkbox" :id="`publish_later${channels[index].id}`" v-model="channels[index].publish_later">
          <label :for="`publish_later${channels[index].id}`">Später veröffentlichen</label>
        </div>
        <div class="form-group" v-if="channels[index].publish_later">
          <label for="publish_at">Veröffentlichungsdatum</label>
          <input type="datetime-local" v-model="channels[index].publish_at" id="publish_at" class="form-control">
        </div>
        <div class="panel panel-success" style="background: #d8ecff; padding: 10px">
          <b> Bitte beachten: </b> Nach dem Teilen des Posts können die Daten der Nachricht nicht mehr bearbeitet
          werden. Sie finden die erstellte Nachricht unter dem Menüpunkt Kampagnensteuerung 3.0 > Nachrichten.
        </div>
        <hr>
        <h3>Selektion</h3>
        <hr>
        <div class="form-group">
          <label for="test_user_ids">Testkundennummern</label>
          <a class="fa fa-question-circle" v-tippy
             content="Testaussendungen im Content-Hub sind erst ab der App-Version 4.1 möglich. Die Kundennummern sind durch Kommata getrennt. Die Testaussendung wird so lange in der App angezeigt wie die Anzeigedauer des Beitrags."></a>
          <input type="text" id="test_user_ids"
                 class="form-control"
                 v-model="channels[index].test_user_ids">
          <button class="btn btn-secondary btn-sm" style="margin-top: 10px" @click="sendToTestUsers">
            <i class="fa fa-share"></i>
            An Testkundennummern aussenden
          </button>
        </div>
        <div :class="{'has-error': submitAttempted && !channels[index].send_info_send_type}">
        <label for="">Aussendungsart</label>
        <select style="margin-bottom: 10px" v-model="channels[index].send_info_send_type" class="form-control"
                :disabled="disabled()"
                required>
          <option value="app_user">An alle App-User zum Startzeitpunkt</option>
          <option value="file">An externe Adressdatei</option>
          <option value="selection">An Kunden aus smart.KIS Selektion</option>
          <option value="registration">Bei Aktivierung und Registrierung</option>
          <option value="sale">Nach Einkauf</option>
          <option value="birthday">Am Geburtstag des App-Users</option>
          <option value="campaign">An alle Kunden, die eine bestimmte Kampagne erhalten</option>
        </select>
        </div>
        <div style="padding-left: 20px" v-if="channels[index].send_info_send_type === 'campaign'"
             :class="{'has-error': submitAttempted && !channels[index].send_info_send_to_v3_campaign_id}">
          <label for="">Verknüpfte Kampagne auswählen</label>
          <select v-model="channels[index].send_info_send_to_v3_campaign_id" class="form-control"
                  style="margin-top: 5px"
                  :disabled="disabled()"
                  required>
            <option :value="null">Kampagne wählen (neueste zuerst)</option>
            <option v-for="campaign in (campaigns || {})[newsHub.client_id]" :value="campaign.id" :key="campaign.id">
              {{ campaign.name_internal }}
            </option>
          </select>
        </div>
        <div style="padding-left: 20px" v-if="channels[index].send_info_send_type === 'selection'"
             :class="{'has-error': submitAttempted && !channels[index].send_info_send_to_selection_id}">
          <label for="">Selektion auswählen</label>
          <select v-model="channels[index].send_info_send_to_selection_id" class="form-control"
                  style="margin-top: 5px"
                  :disabled="disabled()">
            <option v-for="selection in selections[newsHub.client_id]" :value="selection.id" :key="selection.id">
              {{ selection.name }}
            </option>
          </select>
        </div>
        <div style="padding-left: 20px" v-if="channels[index].send_info_send_type === 'file'">
          <label for="">Externe Adressdatei</label>
          <input type="file" @change="addSendInfoFile"
                 :disabled="disabled()">
        </div>

        <br>
        <div class="form-group">
          <label for="send_push_notification">Zusätzlich Push-Nachricht versenden</label>
          <input type="checkbox" v-model="channels[index].send_push_notification" id="send_push_notification"
                 :disabled="!newsHub.is_draft">
        </div>

        <div v-if="channels[index].send_push_notification" class="form-group">
          <label for="">Text der Nachricht*</label>
          <textarea class="form-control" v-model="channels[index].push_notification"
                    :disabled="disabled() || !newsHub.is_draft"></textarea>
        </div>
        <br>
        <p>Status der Aussendung: {{ channels[index].send_info_send_file_info }}</p>
        <button class="btn btn-sm btn-default" style="float:right" @click="deleteChannel"
                content="Aussendungskanal löschen" v-tippy>
          <i class="fa fa-trash-o" style="color: red"></i>
        </button>
      </div>
    </div>
    <div class="panel-body" v-else>
      Es konnte keine App für Ihren Mandanten gefunden werden. <br> <br>
      <a class="btn btn-sm btn-success" href="mailto:info@hutter-unger.de?subject=App-Anfrage">App-Anfrage schicken</a>
      <button class="btn btn-sm btn-default" @click="deleteChannel" :disabled="!newsHub.is_draft"><i
          class="fa fa-trash-o"></i></button>
    </div>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import {mapGetters, mapMutations} from "vuex";
import {editorConfig} from "../editor/config";
import ContentPreview from "../image/ContentPreview";
import MagazineAdditionalContent from "./MagazineAdditionalContent";
import {installSoftBreak} from "../editor/softBreak";

export default {
  name: 'WKZ-Trendblogs',
  components: {ContentPreview, VueToastr, MagazineAdditionalContent},
  props: ['context', 'index', 'newsHub', 'categories', 'campaigns'],
  data() {
    return {

      toolbar: [
        [{header: [false, 1, 2, 3, 4, 5, 6]}],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          {align: ""},
          {align: "center"},
          {align: "right"},
          {align: "justify"}
        ],
        ["blockquote"],
        [{list: "ordered"}, {list: "bullet"}, {list: "check"}],
        [{indent: "-1"}, {indent: "+1"}],
        [{color: []}, {background: []}],
        ["link", "image", "clean"]
      ],
      sendNotify: false,
      notifyCustomers: false,
      editorConfig: editorConfig,
      editorConfigNotification: {
        toolbar: [
          "heading",
          "|",
          "Alignment",
          "fontFamily",
          "FontSize",
          "|",
          "FontColor",
          "fontBackgroundColor",
          "|",
          "Bold",
          "Italic",
          "Underline",
          "Strikethrough",
          "|",
          'undo',
          'redo',
        ]
      }
    }
  },
  methods: {
    channelsUpdated() {
      this.$forceUpdate()
    },
    addAdditionalContent() {
      this.channels[this.index].additional_content.push({
        image_url: null,
        text: null,
        product_marks: []
      });
    },
    addSendInfoFile(event) {
      this.channels[this.index].send_info_send_file = event.target.files[0];

      const formData = new FormData();
      formData.append('file', event.target.files[0]);

      axios.post('/api/content-hub/send_file/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
          .then(response => {
            this.channels[this.index].send_info_send_file = response.data;
            if (response.data.length > 0) {
              this.channels[this.index].send_info_send_file_info = response.data.length + ' Einträge in Datei gefunden.';
            } else {
              this.channels[this.index].send_info_send_file_info = 'Die Datei scheint leer oder ungültig zu sein. Nur XLSX oder CSV UTF-8 mit einer Spalte werden akzeptiert.';
            }
          })
          .catch(error => {
            console.error('Error:', error);
            this.$toastr.e(error.response?.data?.error_message ?? 'Bitte versuchen Sie es noch einmal.', 'Fehler');
          });

    },
    publishLaterIsPast(date) {
      let publishLater = new Date(date);
      let today = new Date();

      return publishLater <= today;
    },
    ...mapMutations(['getChannels', 'removeChannel']),
    deleteChannel() {
      this.removeChannel({id: this.context.id, index: this.index})
      this.$refs.toast.s('Aussendungskanal gelöscht');
    },
    disabled() {
      return this.channels[this.index].state > 13
    },
    sendToTestUsers() {
      this.$parent.saveRecord('test_send');
    }
  },
  computed: {
    ...mapGetters({
      channels: 'getChannels',
      record: 'getRecord',
      selections: 'getSelections',
      internalLinks: 'getInternalLinks',
      submitAttempted: 'getSubmitAttempted'
    }),
    Categories: function () {
      if (this.record) {
        let categories = this.categories[this.record.client_id];
        if (!this.channels[this.index].category_id) this.channels[this.index].category_id = categories[0].id;
        if (typeof categories === 'undefined') {
          return [];
        } else {
          let arr = [];
          for (let cat of categories) {
            arr.push({
              id: cat.id,
              text: cat.name
            });
          }
          return arr;
        }
      } else {
        return [];
      }
    }
  },
  mounted() {
    this.notifyCustomers = !!this.channels[this.index].notify_via;
    if (this.channels[this.index].send_info_send_to_selection_id === 0) {
      try {
        this.channels[this.index].send_info_send_to_selection_id = this.selections[this.newsHub.client_id][0].id;
      } catch {
        this.channels[this.index].send_info_send_to_selection_id = null;
      }
    }

    this.$nextTick(() => {
      installSoftBreak(this.$refs.editor.quill, (clean) => {
        this.channels[this.index].news_content = clean;
      });
    });
  }
}
</script>

<style scoped>
.flex-column {
  display: flex;
  flex-direction: column;
}

</style>
<style>
.ckeditor-wrapper-app .ck-content {
  min-height: 100px;
}

.ckeditor-error .ql-container {
  border-color: #a94442;
}
</style>
